<template lang="pug">
    .category-posts.container(v-if="section.categories")
        .horizontal(v-if="orientation === 'horizontal'")
            loading(:active="loading || fetching" :is-full-page="false" :height="40" :width="40" color="#95c021")
            .teasers(v-if="loading")
                .teaser.skeleton(v-for="teaser in teasers" :style="style")
                    .image
                    .text
            .paginated-teasers(v-else)
                .teasers
                    .teaser(v-for="teaser in teasers" :style="style")
                        Teaser(:teaser="teaser" display="card")
                    // .teaser.skeleton(:style="style")
                    //     .image
                    //     .text
                Pagination(
                    v-if="pageInfo && pageInfo.lastPage > 1"
                    :last-page="pageInfo.lastPage"
                    :current-page="pageInfo.currentPage"
                    nav-class="pagination is-rounded is-centered"
                    @change="changePage"
                )
                    span.icon(slot="prev")
                        font-awesome-icon(icon="arrow-left")
                    span.icon(slot="next")
                        font-awesome-icon(icon="arrow-right")

        .vertical(v-else)
            .column.is-offset-1.is-10
                loading(:active="loading || fetching" :is-full-page="false" :height="40" :width="40" color="#95c021")
                .teasers(v-if="loading")
                    .teaser.skeleton(v-for="teaser in teasers")
                        .image
                        .text
                .paginated-teasers(v-else)
                    .teasers
                        .teaser(v-for="teaser in teasers")
                            Teaser(:teaser="teaser" display="row")
                        // .teaser.skeleton
                        //     .image
                        //     .text
                Pagination(
                    v-if="pageInfo && pageInfo.lastPage > 1"
                    :last-page="pageInfo.lastPage"
                    :current-page="pageInfo.currentPage"
                    nav-class="pagination is-rounded"
                    @change="changePage"
                )
                    span.icon(slot="prev")
                        font-awesome-icon(icon="arrow-left")
                    span.icon(slot="next")
                        font-awesome-icon(icon="arrow-right")

</template>

<script>

// import _ from 'lodash'
import get from 'lodash.get'
import findIndex from 'lodash.findindex'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import store from '@/store'

import Loading from 'vue-loading-overlay'
import Teaser from './Teaser'

import Pagination from '@/components/Pagination'

export default {
    name: 'CategoryPosts',
    props: {
        section: {
            type: Object,
            required: true,
        },
        perPage: {
            type: Number,
            default: 15,
        },
        orientation: {
            type: String,
            default: 'vertical',
        },
    },
    data: () => {
        return {
            fetching: false
        }
    },
    components: {
        Loading,
        Teaser,
        Pagination,
    },
    computed: {
        s() {
            return findIndex(this.sections, { id: this.section.id })
        },
        loading() {
            return get(this.section, 'teasers.loading')
        },
        teasers() {
            let teasers = []
            if (this.loading) {
                if (this.orientation === 'horizontal') teasers = new Array(this.perPage)
                else teasers = new Array(3)
            } else {
                teasers = get(this.section, 'teasers.items')
            }

            return teasers
        },
        pageInfo() {
            return get(this.section, 'teasers.pageInfo')
        },
        style() {
            return {
                width: `calc(${100 / this.perPage}% - 20px)`
            }
        },
        ...mapGetters('currentPage', {
            sections: 'sections',
            // cms: 'CMS'
        })
    },
    methods: {
        changePage(currentPage) {
            // this.updateTeasersLoading({ s: this.s, value: false })
            this.fetching = true

            const payload = {
                pageInfo: {
                    currentPage,
                    perPage: this.perPage,
                },
                filters: [{
                    key: 'categories',
                    in: this.section.categories.map(category => category.id)
                }],
            }
            this.fetchTeasers(payload)
                .then(teasers => this.insertTeasers({ s: this.s, teasers }))
                .finally(() => this.fetching = false)
        },
        ...mapMutations('currentPage', {
            updateTeasersLoading: 'updateCategoryPostTeasersLoading',
            insertTeasers: 'insertCategoryPostTeasers',
        }),
        ...mapActions('currentPage', {
            fetchTeasers: 'fetchCategoryPostTeasers',
        }),
    },
    mounted() {
        const teasers = { loading: true, pagination: {} }
        this.insertTeasers({ s: this.s, teasers })

        const cms = store.getters.CMS.id

        const payload = {
            pageInfo: {
                currentPage: 1,
                perPage: this.perPage,
            },
            filters: [{
                key: 'categories',
                in: this.section.categories.map(category => category.id)
            }, {
                key: 'cms',
                match: cms,
            }],
        }
        this.fetchTeasers(payload)
            .then(teasers => this.insertTeasers({ s: this.s, teasers }))

        // this.updateTeasersLoading({ s: this.s, value: false })
    }
}
</script>

<style lang="scss" scoped>

    @import "~bulma/sass/utilities/mixins";
    @import '~@/assets/sass/variables';
    @import '~empty-state/skeleton';

    $topicColor: #FFD8D8;

    .category-posts /deep/ .pagination-container {
        margin-top: 20px;
        .pagination {
            .pagination-previous,
            .pagination-next {
                padding-left: 0.3em;
                padding-right: 0.3em;
            }
        }
    }

    .category-posts .vertical /deep/ .pagination-container {
        margin-top: 50px;
    }

    .horizontal {
        .teasers {
            text-align: center;
            .teaser {
                margin-bottom: 50px;
                display: inline-block;
                &:last-child {
                    margin-bottom: 10px;
                }
                @include mobile {
                    width: 100% !important;
                    max-width: 360px;
                }

                &.skeleton {
                    .image {
                        padding-bottom: 57%; // ca. 9 / 16
                        background: $skeletonColor;
                        border-radius: 3px;
                    }
                    .text {
                        // $imageHeight: 140px;
                        $imageHeight: 0px;
                        $margin: 20px;
                        $topicHeight: 12px;
                        $headingHeight: 22px;
                        $headingGutter: 6px;
                        $teaserHeight: 12px;
                        $teaserGutter: 4px;

                        $headingLines: 2;
                        $teaserLines: 5;

                        $headingY: $imageHeight + $margin + $topicHeight + $margin;
                        $teaserY: $headingY + $headingLines * ($headingHeight + $headingGutter) - $headingGutter + $margin;

                        $height: $teaserY + $teaserLines * ($teaserHeight + $teaserGutter) - $teaserGutter;

                        $shapes: (
                            // rect(#D8D8D8, 100%, $imageHeight, 0, 0),
                            rect($topicColor, 140px, $topicHeight, 0, $imageHeight + $margin),
                        );

                        $shapes: join($shapes, lines($headingLines, $skeletonColor, 100%, $headingHeight, $headingGutter, 0, $headingY, 60%));
                        $shapes: join($shapes, lines($teaserLines, $skeletonColor, 100%, $teaserHeight, $teaserGutter, 0, $teaserY, 30%));
                        @include skeleton($shapes...);

                        height: $height;
                    }
                }
            }
            @include tablet {
                margin: -10px;
                display: flex;
                flex-direction: row;
                justify-content: center;
                .teaser {
                    margin:  10px;
                    margin-bottom: 10px;
                    flex-grow: 0;
                    flex-shrink: 0;
                }
            }
        }
    }

    .vertical {
        .teasers {
            text-align: center;
            .teaser {
                margin-bottom: 50px;
                &:last-child {
                    margin-bottom: 10px;
                }
                @include mobile {
                    width: 100% !important;
                    max-width: 360px;
                    display: inline-block;
                }
                &.skeleton {
                    .image {
                        padding-bottom: 57%; // ca. 9 / 16
                        background: $skeletonColor;
                        border-radius: 3px;
                        margin-bottom: 20px;
                        @include tablet {
                            padding-bottom: initial;
                            margin-bottom: 0;
                            height: 180px;
                            width: 320px;
                            flex-basis: 320px;
                            flex-grow: 0;
                            flex-shrink: 0;
                        }
                    }
                    .text {
                        $margin: 20px;
                        $topicHeight: 12px;
                        $headingHeight: 22px;
                        $headingGutter: 6px;
                        $teaserHeight: 12px;
                        $teaserGutter: 4px;

                        $headingLines: 2;
                        $teaserLines: 5;

                        $headingY: $topicHeight + $margin;
                        $teaserY: $headingY + $headingLines * ($headingHeight + $headingGutter) - $headingGutter + $margin;

                        $height: $teaserY + $teaserLines * ($teaserHeight + $teaserGutter) - $teaserGutter;

                        $shapes: (
                            // rect(#D8D8D8, 100%, $imageHeight, 0, 0),
                            rect($topicColor, 140px, $topicHeight, 0, 0),
                        );

                        $shapes: join($shapes, lines($headingLines, $skeletonColor, 100%, $headingHeight, $headingGutter, 0, $headingY, 60%));
                        $shapes: join($shapes, lines($teaserLines, $skeletonColor, 100%, $teaserHeight, $teaserGutter, 0, $teaserY, 30%));
                        @include skeleton($shapes...);

                        height: $height;

                        @include tablet {
                            flex-grow: 1;
                            margin-left: 20px;
                        }
                    }
                    @include tablet {
                        display: flex;
                        flex-direction: row;
                    }
                }
            }
        }
    }

</style>
